import { React, useEffect, useState } from "react";
import { Logo } from "../../../../components/Logo";
import { Get, GetFile } from "../../../../actions";
import { Get_Logo_URL } from "../../../../constants/apiUrls";
import LogoFile1 from "../../../../assests/images/restobizLogo.png"

const Footer = ({ classes, enableLogo }) => {
	const [src, setSrc] = useState("");

	useEffect(() => {
		Get(
			{},
			Get_Logo_URL,
			null,
			(res) => {
				if(res?.data)
				setSrc(GetFile(res.data));
			else
				setSrc(LogoFile1);
			},
			(err) => {}
		);
	}, []);

	return (
		<div className={classes.footer}>
			<div className={classes.footerLogoWrapper}>
				{enableLogo ? (
					src ? (
						<img
							alt="SystemSettingLogo"
							src={src}
							style={{ width: "100%", height: "100%", margin: "5px" }}
						/>
					) : (
						<Logo className={classes.img} />
					)
				) : null}
			</div>
		</div>
	);
};

export default Footer;
